module.exports = __webpack_public_path__ + "files/gagneux brunon.d13c2fe6825645126c4b9d196827e38a.pdf";